/** Language codes accepted in `/{lang}/...` public URLs. */
export const LOCALE_CODES = ['en', 'fa', 'fr', 'ar', 'de', 'es'];

/** Default languages emitted in sitemap / hreflang when Admin config is unavailable. */
export const DEFAULT_SEO_LOCALES = ['en', 'fa', 'fr', 'ar'];

/** @type {import('@sveltejs/kit').ParamMatcher} */
export function match(param) {
	return LOCALE_CODES.includes(String(param || '').toLowerCase());
}
